import { render, staticRenderFns } from "./AlarmRecord.vue?vue&type=template&id=694c5eb1&scoped=true&"
import script from "./AlarmRecord.vue?vue&type=script&lang=js&"
export * from "./AlarmRecord.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRecord.vue?vue&type=style&index=0&id=694c5eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c5eb1",
  null
  
)

export default component.exports